import React, { useEffect, useMemo, useState } from "react";
import { SidebarNavigation } from "../Home/SidebarNavigation";
import { appsData, NavigationItem } from "../Home/data/appsData";
import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import {
  collapseLeftMenu,
  updateSelectedMenu,
  updateStoreList,
} from "./action";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SvgLoader } from "../../utils/svgLoader.tsx";
import {
  getProfile,
  updateLastActiveWsStore,
  updateProfileData,
} from "../../utils/account.js";
import {
  getHighestRoleInWorkspace,
  getWorkspaces,
} from "../../utils/workspaces.js";
import { updateSelectedWorkspace } from "../../globalActions.js";
import { getInitials, getQueryParamsAsObj } from "../../utils/utils.js";
import { getStores } from "../../utils/store.js";
import Intercom, { show } from "@intercom/messenger-js-sdk";
import collapseIcon from "../../Icons/collapse-icon.svg";
import liveSupportIcon from "../../Icons/live-support-icon.svg";
import appLogoIcon from "../../Icons/app-logo.svg";
import appLogoSmall from "../../Icons/logo.svg";

import AppSettingsPopup from "../AppSettingsPopup/index.tsx";
import OutsideClick from "../commonComponents/OutsideClick/index.tsx";
import SupportLoader from "../commonComponents/SupportLoader/index.tsx";

const LeftMenu: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    globalReducer: {
      userData,
      userPreferences,
      appVersion,
      fetchingWorkspaces,
      workspaces,
      selectedWorkspace,
      fetchingStores,
      stores,
      fetchingSelectedStore,
      selectedStore,
      version,
      userRole,
      loadingFeatureFlags,
    },
  } = useSelector((store) => store);

  const params = useParams();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeSection, setActiveSection] = useState<string>("home");
  const [showAppSettingsPopUp, setShowAppSettingsPopUp] =
    useState<boolean>(false);
  const [loadingLiveSupport, setLoadingLiveSupport] = useState(false);
  // Update navigation items based on active section
  const navigationItems = useMemo(
    () =>
      appsData.sidebarNavigation.map((item) => ({
        ...item,
        active: item.id === activeSection,
      })),
    [activeSection]
  );

  useEffect(() => {
    getProfile()
      .then((res) => {
        // console.log(res);
        setIsLoggedIn(true);
      })
      .catch((err) => {
        console.log("Error: ", err);
        navigate("/login");
      });
  }, []);
  useEffect(() => {
    if (isLoggedIn) {
    }
  }, [params.workspaceId, isLoggedIn]);

  useEffect(() => {
    const activeSectionState = appsData.sidebarNavigation.find(
      (nav) =>
        location.pathname === `/${nav.route}` ||
        location.pathname.startsWith(`/${nav.route}/`)
    );
    if (activeSectionState) {
      // let selectedSectionId =

      setActiveSection(activeSectionState.id);

      const action = updateSelectedMenu(activeSectionState.id);
      if (action) {
        dispatch(action);
      }
    } else {
      setActiveSection("apps");
    }
  }, [location]);

  const redirectTo = (path) => {
    navigate(path);
  };

  const handleNavigation = (sectionId: string, item: NavigationItem) => {
    setActiveSection(sectionId);
    // redirectTo(item.route);
    navigate("/" + item.route);
  };

  const updateUser = async (key, value) => {
    await updateProfileData({ [key]: JSON.stringify(value) }).then((res) => {
      if (res.data) {
      }
      return null;
    });
  };

  return (
    <div
      className={`app-sidebar-nav ${
        userPreferences && userPreferences.sidebarIsCollapsed
          ? "collapsed-left-menu"
          : ""
      }
    
    `}
    >
      <div className="top-section">
        <div
          className="app-logo w-full"
          onClick={() => {
            redirectTo("workspace");
          }}
        >
          <div className="relative shrink-0 height-[32px] w-full">
            <img
              src={
                userPreferences && userPreferences.sidebarIsCollapsed
                  ? appLogoSmall
                  : appLogoIcon
              }
              alt="app logo"
            />
          </div>

          {/* <div className="app-logo-text">
            <p
              className="block leading-[26px] whitespace-pre header-title"
              style={{ marginLeft: "0px" }}
            >
              Streamoid
            </p>
          </div> */}
        </div>
        <SidebarNavigation
          items={navigationItems}
          onNavigate={handleNavigation}
        />
      </div>
      <div className="bottom-section">
        <div className="app-workspace-container">
          <div className="app-workspace-content">
            <div
              className="app-workspace-inner cursor-pointer workspace-name-container"
              onClick={() => {
                navigate("/profile");
              }}
            >
              <div className="app-workspace-image">
                {userData && userData.imageUrl ? (
                  <img
                    className="bg-center bg-cover bg-no-repeat h-[32px] rounded-[1000px] shrink-0 w-[32px] object-cover"
                    src={userData.imageUrl}
                    alt="workspace image"
                  />
                ) : (
                  <div className="bg-center bg-cover bg-no-repeat h-[32px] rounded-[1000px] shrink-0 w-[32px] default-icon">
                    {userData && getInitials(userData.name || userData.email)}
                  </div>
                )}
              </div>
              <div className="app-workspace-text app-workspace-details">
                <div className="app-workspace-title">
                  <div className="block leading-[18px] workspace-name">
                    {userData && userData.name}
                  </div>
                </div>
              </div>

              {/* {showAppSettingsPopUp && (
                  <AppSettingsPopup
                    onClose={() => {
                      setShowAppSettingsPopUp(false);
                    }}
                  ></AppSettingsPopup>
                )} */}
            </div>
            {userPreferences && !userPreferences.sidebarIsCollapsed && (
              <>
                <div
                  className="collapse-icon h-[40px] w-[40px] flex justify-center items-center cursor-pointer"
                  onClick={() => {
                    const action = collapseLeftMenu(
                      !userPreferences.sidebarIsCollapsed
                    );
                    dispatch(action);
                    updateUser("userPreferences", {
                      ...userPreferences.sidebarIsCollapsed,
                      sidebarIsCollapsed: !userPreferences.sidebarIsCollapsed,
                    });
                  }}
                >
                  <img
                    src={collapseIcon}
                    alt="collapse icon"
                    className=" h-[24px] w[24px]"
                  />
                </div>
              </>
            )}
          </div>
        </div>
        {userPreferences && userPreferences.sidebarIsCollapsed && (
          <div className={"options"}>
            <div className="option">
              <div
                className="option-icon"
                onClick={() => {
                  const action = collapseLeftMenu(
                    !userPreferences.sidebarIsCollapsed
                  );
                  dispatch(action);
                  updateUser("userPreferences", {
                    ...userPreferences.sidebarIsCollapsed,
                    sidebarIsCollapsed: !userPreferences.sidebarIsCollapsed,
                  });
                }}
              >
                <img
                  src={collapseIcon}
                  alt="collapse icon"
                  className=" h-[24px] w[24px] collapse-icon"
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {appVersion && <div className="version">v{appVersion}</div>}
    </div>
  );
};

export default LeftMenu;
